// extracted by mini-css-extract-plugin
export default {"heading":"WarehouseDetail_heading__-S4vw","wrapper":"WarehouseDetail_wrapper__4kEsO"};